import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/+$/, "");
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const detail = (err?.response?.data?.detail || "").toLowerCase();
    const isExpiry = detail.includes("habis") || detail.includes("expired") || detail.includes("masa aktif");
    if (status === 401 || (status === 403 && isExpiry)) {
      const hadToken = !!localStorage.getItem("pp_token");
      localStorage.removeItem("pp_token");
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/admin")) {
        if (isExpiry) localStorage.setItem("pp_expired", "1");
        else if (hadToken) localStorage.setItem("pp_session_ended", "1");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

// Separate instance for admin endpoints (uses the admin session token).
export const adminApi = axios.create({ baseURL: API_BASE });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("pp_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
